import { useDispatch, useSelector } from 'react-redux';
import { sendApply } from '../../../actions/form/sendApply';
import { ISaveApplyRequestV2Schema } from '../../../common/repositories/job-vacancies-backend/entities/apply/SaveApplyRequestV2Schema';
import { selectVacancy } from '../../../selectors/vacancies';
import { TThunkDispatch } from '../../../types/redux';
import { sendRecommendation } from '../../../actions/form/sendRecommendation';
import { ISaveRecommendationRequestV2Schema } from '../../../common/repositories/job-vacancies-backend/entities/apply/SaveRecommendationRequestV2Schema';
import { selectForm } from '../../../selectors/form';

export const useApply = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const vacancy = useSelector(selectVacancy);
  const { inputsState } = useSelector(selectForm);
  const isAgreementChecked = inputsState.agreement;

  const onApply = () => {
    dispatch(
      sendApply({
        ...inputsState,
        phone: inputsState.phone ? `+${inputsState.phone}` : '',
        vacancyId: vacancy?.id as number,
        agreement: {
          fileHash: isAgreementChecked ? (vacancy?.agreement.fileHash as string) : '',
        },
      } as ISaveApplyRequestV2Schema),
    );
  };

  const onRecommend = () => {
    dispatch(
      sendRecommendation({
        ...inputsState,
        phone: inputsState.phone ? `+${inputsState.phone}` : '',
        vacancyId: vacancy?.id as number,
        agreement: {
          fileHash: isAgreementChecked ? (vacancy?.agreementRec.fileHash as string) : '',
        },
      } as ISaveRecommendationRequestV2Schema),
    );
  };

  return {
    onApply,
    onRecommend,
  };
};
